"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  IS_APPLE: function IS_APPLE() {
    return _IS_APPLE;
  },
  escapeRegExp: function escapeRegExp() {
    return _escapeRegExp;
  },
  findHtmlParentElement: function findHtmlParentElement() {
    return _findHtmlParentElement2;
  },
  getHandler: function getHandler() {
    return _getHandler;
  },
  hexToBase64: function hexToBase64() {
    return _hexToBase;
  },
  isDefined: function isDefined() {
    return _isDefined;
  },
  isNull: function isNull() {
    return _isNull;
  },
  isUndefined: function isUndefined() {
    return _isUndefined;
  },
  isUndefinedOrNull: function isUndefinedOrNull() {
    return _isUndefinedOrNull;
  },
  isUrl: function isUrl() {
    return _isUrl;
  },
  mergeProps: function mergeProps() {
    return _mergeProps;
  },
  sanitizeUrl: function sanitizeUrl() {
    return _sanitizeUrl;
  }
});
module.exports = __toCommonJS(src_exports);

// src/environment.ts
var _IS_APPLE = typeof navigator !== "undefined" && /Mac OS X/.test(navigator.userAgent);

// src/escapeRegexp.ts
var _escapeRegExp = function _escapeRegExp(text) {
  return text.replaceAll(/[#$()*+,.?[\\\]^s{|}-]/g, "\\$&");
};

// src/findHtmlParentElement.ts
var _findHtmlParentElement2 = function _findHtmlParentElement(el, nodeName) {
  if (!el || el.nodeName === nodeName) {
    return el;
  }
  return _findHtmlParentElement2(el.parentElement, nodeName);
};

// src/getHandler.ts
var _getHandler = function _getHandler(cb) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return function () {
    cb == null ? void 0 : cb.apply(void 0, args);
  };
};

// src/hexToBase64.ts
var _hexToBase = function _hexToBase(hex) {
  var hexPairs = hex.match(/\w{2}/g) || [];
  var binary = hexPairs.map(function (hexPair) {
    return String.fromCodePoint(Number.parseInt(hexPair, 16));
  });
  return btoa(binary.join(""));
};

// src/isUrl.ts
var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var emailLintRE = /mailto:([^?\\]+)/;
var localhostDomainRE = /^localhost[\d:?]*(?:[^\d:?]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s.]+\.\S{2,}$/;
var _isUrl = function _isUrl(string) {
  if (typeof string !== "string") {
    return false;
  }
  var generalMatch = string.match(protocolAndDomainRE);
  var emailLinkMatch = string.match(emailLintRE);
  var match = generalMatch || emailLinkMatch;
  if (!match) {
    return false;
  }
  var everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }
  try {
    new URL(string);
  } catch (e) {
    return false;
  }
  return localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol);
};

// src/mergeProps.ts
var _mergeProps = function _mergeProps(props, overrideProps) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    handlerKeys = _ref.handlerKeys,
    _ref$handlerQuery = _ref.handlerQuery,
    handlerQuery = _ref$handlerQuery === void 0 ? function (key) {
      return key.indexOf("on") === 0;
    } : _ref$handlerQuery;
  var map = /* @__PURE__ */new Map();
  var acc = {};
  var mapProps = function mapProps(_props) {
    if (!_props) return;
    Object.entries(_props).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      var _a;
      if ((!handlerKeys || handlerKeys.includes(key)) && (!handlerQuery || handlerQuery(key)) && typeof value === "function") {
        if (!map.has(key)) {
          map.set(key, []);
        }
        (_a = map.get(key)) == null ? void 0 : _a.push(value);
        acc[key] = function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          var _a2;
          (_a2 = map.get(key)) == null ? void 0 : _a2.forEach(function (fn) {
            return fn.apply(void 0, args);
          });
        };
      } else {
        acc[key] = value;
      }
    });
  };
  mapProps(props);
  mapProps(overrideProps);
  return acc;
};

// src/sanitizeUrl.ts
var _sanitizeUrl = function _sanitizeUrl(url, _ref4) {
  var allowedSchemes = _ref4.allowedSchemes,
    _ref4$permitInvalid = _ref4.permitInvalid,
    permitInvalid = _ref4$permitInvalid === void 0 ? false : _ref4$permitInvalid;
  if (!url) return null;
  var parsedUrl = null;
  try {
    parsedUrl = new URL(url);
  } catch (e) {
    return permitInvalid ? url : null;
  }
  if (allowedSchemes && !allowedSchemes.includes(parsedUrl.protocol.slice(0, -1))) {
    return null;
  }
  return parsedUrl.href;
};

// src/type-utils.ts
var _isUndefined = function _isUndefined(obj) {
  return obj === void 0;
};
var _isNull = function _isNull(obj) {
  return obj === null;
};
var _isUndefinedOrNull = function _isUndefinedOrNull(obj) {
  return _isUndefined(obj) || _isNull(obj);
};
var _isDefined = function _isDefined(arg) {
  return !_isUndefinedOrNull(arg);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  IS_APPLE: _IS_APPLE,
  escapeRegExp: _escapeRegExp,
  findHtmlParentElement: _findHtmlParentElement2,
  getHandler: _getHandler,
  hexToBase64: _hexToBase,
  isDefined: _isDefined,
  isNull: _isNull,
  isUndefined: _isUndefined,
  isUndefinedOrNull: _isUndefinedOrNull,
  isUrl: _isUrl,
  mergeProps: _mergeProps,
  sanitizeUrl: _sanitizeUrl
});